import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Mamás latinas en EE.UU. con hijos en edad escolar.', 'Mujeres que trabajan y necesitan soluciones de máximo 10 minutos.', 'Padres cansados de gastar $5 diarios en la cafetería escolar.', 'Familias que quieren balancear la salud con el sabor de nuestra cultura.'];
  const isNotFor = ['Personas que no viven en Estados Unidos (las marcas y guías son específicas para este mercado).', 'Quienes disfrutan pasar 2 horas diarias cocinando.', 'Familias con servicios de comida preparada o chefs privados.'];
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-3">
          {/* Is For */}
          <div className="bg-brand-cream/30 rounded-3xl p-8 border-t-8 border-brand-teal shadow-sm" data-id="element-4">
            <h3 className="text-2xl font-bold text-brand-brown mb-8 flex items-center gap-3" data-id="element-5">
              <span className="bg-brand-teal/20 text-brand-teal p-2 rounded-full" data-id="element-6">
                <CheckIcon className="w-6 h-6" data-id="element-7" />
              </span>
              Esto ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-8">
              {isFor.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-9">
                  <CheckIcon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-1" data-id="element-10" />
                  <span className="text-brand-brown/80 text-lg" data-id="element-11">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Is Not For */}
          <div className="bg-brand-cream/30 rounded-3xl p-8 border-t-8 border-brand-coral shadow-sm" data-id="element-12">
            <h3 className="text-2xl font-bold text-brand-brown mb-8 flex items-center gap-3" data-id="element-13">
              <span className="bg-brand-coral/20 text-brand-coral p-2 rounded-full" data-id="element-14">
                <XIcon className="w-6 h-6" data-id="element-15" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-16">
              {isNotFor.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-17">
                  <XIcon className="w-5 h-5 text-brand-coral flex-shrink-0 mt-1" data-id="element-18" />
                  <span className="text-brand-brown/80 text-lg" data-id="element-19">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}